import { defineNuxtRouteMiddleware, useLayoutLoad, usePageLoad } from '#imports';

export default defineNuxtRouteMiddleware(async route => {
    if (import.meta.server) {
        try {
            await Promise.all([
                useLayoutLoad(),
                usePageLoad(route),
            ]);
        } catch (error) {
            console.error('SSR: Error loading layout or page:', error);
        }
    }
});
